import {$} from '../util/jq';
import mappings from '../pageMappings';

const navButtons = ['.next', '.previous', '.nextAsync', '.previousAsync'];

export default (
  oldContentWrapper,
  oldContentSelectors,
  newContentWrapper,
  newContentSelectors,
  template,
  reverse,
  url
) => {

  const getContent = (parent, selectors) =>
    selectors
      .map(s => parent.find(s))
      .reduce(((accumulator, currentValue) => accumulator.add(currentValue)), $([]));

  const oldContent = getContent(oldContentWrapper, oldContentSelectors);

  window.guide.history.push(url);

  // Prep the new elements before adding them to the page.
  const newContent = getContent(newContentWrapper, newContentSelectors);
  const txClasses = [reverse ? 'transitioningBackIn' : 'transitioningIn', 'transitioningOut'];
  newContentWrapper.addClass(txClasses[0]);

  // Add the new content to the page, and begin process of removing old content.
  $('body').addClass('transitioningPage');
  newContentWrapper.insertAfter(oldContentWrapper);
  oldContentWrapper.removeAttr('id');
  oldContentWrapper.addClass(txClasses[1]);
  newContentWrapper.attr('id', 'contentWrapper');
  mappings[template]();
  $('body').css('overflow-x', 'hidden');
  newContent.addClass('transitioningChild');
  oldContent.addClass('transitioningChild');

  const movement = `${reverse ? '+' : '-'}=100vw`;
  const animation = {left: movement};
  const animationDuration = 400;

  // Perform animation, and finally remove old content.
  oldContent.animate(animation, animationDuration, () => {
    oldContentWrapper.remove();
    $('body').css('overflow-x', '');
  });
  newContent.animate(animation, animationDuration, () => {
    navButtons.forEach(selector => {
      $(selector).prop('disabled', false);
    });
    newContentWrapper.removeClass(txClasses[0]);
    newContent.css('left', '');
    newContent.removeClass('transitioningChild');
    $('body').removeClass('transitioningPage');
  });

};



// WEBPACK FOOTER //
// ./src/main/js/pageTransitions/_customTx.js